import { Component, Vue } from 'vue-property-decorator';
import { getArea } from '@/api/deviceManaging';
import { iArea } from '@/interface/result';
@Component
export class GameArea extends Vue {
  private areas: { id: number; name: string }[] = [];

  areaIdToName(id: number = 0) {
    let obj: iArea | undefined;
    obj = this.areas.find((el: iArea) => el.id === id);
    if (obj) return obj.name;
  }

  showConfig(c: number) {
    switch (c) {
      case (c = 1):
        return '标配';
      case (c = 2):
        return '高配';
      case (c = 4):
        return '尊享';
    }
  }

  // showStatus(s: number): string {
  //   switch (s) {
  //     case (s = 1):
  //       return '使用';
  //     case (s = 2):
  //       return '空闲';
  //     case (s = 3):
  //       return '离线';
  //     case (s = 4):
  //       return '故障';
  //     case (s = 5):
  //       return '维护';
  //     default:
  //       return '全部';
  //   }
  // }

  async getAreas() {
    try {
      const res = await getArea();
      if (res) {
        this.areas = res.data;
      }
    } catch (error) {
      console.log(error);
    }
  }

  created() {
    this.getAreas();
  }
}
